// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tag } from "antd";
import { SURVEY_WORKFLOW_RESULTS_STATUS } from "../../../../utils/Constant";

type SurveyTypeProps = {
  status: string;
};

const SurveyResultsStatusTag: React.FunctionComponent<SurveyTypeProps> = (
  props: SurveyTypeProps
) => {
  const { status } = props;
  if (status === "") {
    return null;
  } else {
    return (
      <Tag color={SURVEY_WORKFLOW_RESULTS_STATUS[status].color}>
        {SURVEY_WORKFLOW_RESULTS_STATUS[status].label}
      </Tag>
    );
  }
};

export default SurveyResultsStatusTag;
